export default "__VITE_ASSET__84cad312__"